'use client';

import { useRef, type ChangeEvent } from 'react';
import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { usePipelineStore } from '@/lib/pipeline/store';
import { ParamNameField } from '../ParamNameField';

export default function ImageUploadNode({ id, data }: NodeProps) {
  const update = usePipelineStore((s) => s.updateNodeData);
  const inputRef = useRef<HTMLInputElement>(null);
  const d = data as { image?: string | null; name?: string | null; param?: string | null };

  const onFile = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fr = new FileReader();
    fr.onload = () => update(id, { image: fr.result as string, name: file.name });
    fr.readAsDataURL(file);
  };

  return (
    <NodeShell id={id} type="imageUpload">
      {d.image ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={d.image} alt={d.name ?? 'uploaded'} className="rounded-lg w-full" />
      ) : (
        <div className="text-xs text-[var(--text-muted)] py-6 text-center border border-dashed border-[var(--border-subtle)] rounded-lg">
          No image
        </div>
      )}
      <button
        onClick={() => inputRef.current?.click()}
        className="btn btn-ghost nodrag w-full text-xs h-8 mt-1"
      >
        {d.image ? 'Change' : 'Upload image'}
      </button>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} />
      <ParamNameField id={id} value={d.param} />
    </NodeShell>
  );
}
